const VerticalDivider = () => {
  return <div style={{ width: '1px', height: '35px', backgroundColor: '#EAEEF6' }}></div>;
};

export default VerticalDivider;
